
  export default {
    name: 'About',
    created(){
        document.title = "ProjectLifeKey | The guardian angel of your projects"
    }
  }
